module.exports = __webpack_public_path__ + "img/add-circle.1c434eb2.svg";